import { render } from "./InActiveUserAccounts.vue?vue&type=template&id=06ee27f0"
import script from "./InActiveUserAccounts.vue?vue&type=script&lang=js"
export * from "./InActiveUserAccounts.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/userAccounts/InActiveUserAccounts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06ee27f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06ee27f0', __exports__)) {
    console.log('reload')
    api.reload('06ee27f0', __exports__)
  }
  
  module.hot.accept("./InActiveUserAccounts.vue?vue&type=template&id=06ee27f0", () => {
    console.log('re-render')
    api.rerender('06ee27f0', render)
  })

}


export default __exports__